import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import commonStyles from 'styles/common.pcss';
import { hideThreeFoursModal } from 'store/widgets/ThreeFours/actions';
import {
  getThreeFoursAuthFormData,
  getThreeFoursOfferUrl,
  getThreeFoursOfferUrlTitle,
  getThreeFoursRedirectUrl,
  getThreeFoursModalIsOpen,
} from 'store/widgets/ThreeFours/selectors';
import { ContentWrap } from 'bricks';

import AuthForm from '../AuthForm';
import ModalPopup from './components/ModalPopup';
import styles from './styles.pcss';

const cx = classNames.bind({ ...commonStyles, ...styles });

class AuthModal extends React.Component {
  handleRedirect = () => {
    const { redirectUrl } = this.props;
    window.location.href = redirectUrl;
  };

  render() {
    const { isActive, authFormData, offerUrl, offerUrlTitle, onClose } = this.props;

    return (
      <ModalPopup isActive={isActive} onClose={onClose}>
        <ContentWrap className={cx('container')}>
          <AuthForm
            {...authFormData}
            description={null}
            onRedirect={this.handleRedirect}
            isCompact
            className={cx('marb-xs')}
          >
            <div className={cx('marb-xs')}>{authFormData.description}</div>
          </AuthForm>
          {offerUrl && offerUrlTitle ?
            <div className={cx('link')}>
              <a href={offerUrl}>{offerUrlTitle}</a>
            </div>
          : null}
        </ContentWrap>
      </ModalPopup>
    );
  }
}

AuthModal.propTypes = {
  /** redux props */
  isActive: PropTypes.bool,
  authFormData: PropTypes.object,
  offerUrl: PropTypes.string,
  offerUrlTitle: PropTypes.string,
  redirectUrl: PropTypes.string,
  onClose: PropTypes.func,
};

const mapStateToProps = (state) => ({
  isActive: getThreeFoursModalIsOpen(state),
  authFormData: getThreeFoursAuthFormData(state),
  offerUrl: getThreeFoursOfferUrl(state),
  offerUrlTitle: getThreeFoursOfferUrlTitle(state),
  redirectUrl: getThreeFoursRedirectUrl(state),
});

const mapDispatchToProps = {
  onClose: hideThreeFoursModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthModal);
